import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    contentCtaContainerInner: 'flex gap-4 wrap lg:gap-6 <md:grow'
  }
} satisfies RecursivePartial<CMSConfig['hero']>
